import * as React from 'react';
import { useMemo, useRef } from 'react';
import AliceCarousel from 'react-alice-carousel';
import { cn, JobSimilarPositionsProps, useResponsiveBreakPoints } from '@restworld/utils-common';

import JobPositionCard from '../job-position-card';
import { CarouselNavigation } from '@restworld/ui-components';

export type JobPositionCardCarouselProps = JobSimilarPositionsProps & {
  cardStyling?: string | string[];
  cardContainerStyling?: string | string[];
  cardVariant?: 'job-offer' | 'restaurant' | 'job-proposal';
  onSlideChanged?: (slideItem: number) => void;
  activeIndex?: number;
};

export function JobPositionCardCarousel({
  items,
  cardStyling,
  cardContainerStyling,
  cardVariant,
  onSlideChanged,
  activeIndex,
}: JobPositionCardCarouselProps) {
  const { isLargeDesktop, isTablet } = useResponsiveBreakPoints();
  const carouselRef = useRef<AliceCarousel>(null);
  const itemsElement = useMemo(
    () =>
      items.map((v, i) => (
        <CardContainerStyled cardContainerStyling={cardContainerStyling} key={i}>
          <JobPositionCard key={i} {...v} twStyle={cardStyling} cardVariant={cardVariant} />
        </CardContainerStyled>
      )),
    [cardContainerStyling, cardStyling, cardVariant, items]
  );
  return (
    <Wrapper>
      <AliceCarousel
        mouseTracking
        disableButtonsControls
        disableDotsControls
        keyboardNavigation={false}
        touchTracking
        ref={carouselRef}
        items={itemsElement}
        autoWidth
        paddingRight={100}
        controlsStrategy="responsive"
        onSlideChanged={onSlideChanged ? (e) => onSlideChanged(e.item) : undefined}
        activeIndex={activeIndex}
      />
      {(isLargeDesktop ? itemsElement.length > 4 : isTablet ? itemsElement.length > 2 : itemsElement.length > 1) && (
        <CarouselNavigation carouselRef={carouselRef} />
      )}
    </Wrapper>
  );
}
export default JobPositionCardCarousel;
const Wrapper = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  // jp-card-carousel: opt this carousel into the equal-height stage rules in GlobalStyles so
  // cards with taller content don't drop their CTA below the shorter ones.
  <div className={cn('jp-card-carousel w-full relative overflow-hidden', className)} {...props} />
);
const CardContainerStyled = ({
  cardContainerStyling,
  className,
  children,
  ...props
}: Pick<JobPositionCardCarouselProps, 'cardContainerStyling'> & React.HTMLAttributes<HTMLDivElement>) => (
  <div className={cn('w-[20rem] mr-2 h-full', cardContainerStyling, className)} {...props}>
    {children}
  </div>
);
